import { Config } from "./interfaces/config";
import { getEnv } from "./utils/env";
import {
  lp,
  dmmLP,
  farmToken,
  newFarmToken,
  pairs,
  newPairs,
  fixAPRLockTokenChangeRatio,
  fixAPRLockToken,
  earnOtherToken,
  fixAPRToken,
  stakeToken,
  bondToken,
  swapTokens,
  loansDepositTokens,
  loansRepayTokens,
  bridgeTokens,
  solTokens,
  oracleTokens,
  eTokenList,
  eTokenBorrowList,
  token,
  newPairOmniRewards,
} from "./token-config";
import { networks, networkSol } from "./network-config";

const config: Config = {
  chainId: parseInt(getEnv("REACT_APP_CHAIN_ID") ?? "56"),
  loans: {
    depositTokens: loansDepositTokens,
    repayTokens: loansRepayTokens,
  },
  bridgeTokens,
  swapTokens,
  eTokenList,
  eTokenBorrowList,
  loansCurrency: getEnv("REACT_APP_LOANS_CURRENCY"),
  solTokens,
  slippagePercentage: getEnv("REACT_APP_SLIPPAGE_PERCENTAGE"),
  chainNetworkName: getEnv("REACT_APP_CHAIN_NETWORK_NAME"),
  chainRPC: getEnv("REACT_APP_CHAIN_RPC"),
  solAppCluster: getEnv("REACT_APP_SOL_PP_CLUSTER"),
  wormholeSOLChainId: getEnv("REACT_APP_WORMHOLE_SOL_CHAIN_ID"),
  wormholeBNBChainId: getEnv("REACT_APP_WORMHOLE_BNB_CHAIN_ID"),
  ethChainRPC: getEnv("REACT_APP_ETH_CHAIN_RPC"),
  evrynetTokenETH: getEnv("REACT_APP_ETH_EVRY_TOKEN"),
  solProgramId: getEnv("REACT_APP_SOL_PROGRAM_ID"),
  releaseController: {
    founderAndTeamAddress: getEnv("REACT_APP_ETH_FOUNDER_AND_TEAM_ADDRESS"),
    ecosystemAddress: getEnv("REACT_APP_ETH_ECOSYSTEM_ADDRESS"),
    partnerAddress: getEnv("REACT_APP_ETH_PARTNER_ADDRESS"),
    advisorAddress: getEnv("REACT_APP_ETH_ADVISOR_ADDRESS"),
    earlyBackerAddress: getEnv("REACT_APP_ETH_EARLY_BACKER_ADDRESS"),
    reserveFundAddress: getEnv("REACT_APP_ETH_RESERVE_FUND_ADDRESS"),
    privateSalesAddress: getEnv("REACT_APP_ETH_PRIVATE_SALES_ADDRESS"),
  },
  timebaseAddress: getEnv("REACT_APP_TIME_BASE_ADDRESS"),
  performanceAddress: getEnv("REACT_APP_PERFORMANCE_ADDRESS"),
  chainCurrencySymbol: getEnv("REACT_APP_CHAIN_CURRENCY_SYMBOL"),
  chainExplorerURL: getEnv("REACT_APP_CHAIN_EXPLORER_URL"),
  solChainExplorerURL: getEnv("REACT_APP_SOL_CHAIN_EXPLORER_URL"),
  ammRouterContractAddress: getEnv("REACT_APP_AMM_ROUTER_CONTRACT_ADDRESS"),
  dmmRouterContractAddress: getEnv("REACT_APP_DMM_ROUTER_CONTRACT_ADDRESS"),
  wormholeBSCTokenBridgeAddress:
    getEnv("REACT_APP_WORMHOLE_BSC_TOKEN_BRIDGE_ADDRESS"),
  wormholeSOLTokenBridgeAddress:
    getEnv("REACT_APP_WORMHOLE_SOL_TOKEN_BRIDGE_ADDRESS"),
  wormholeBSCBridgeAddress: getEnv("REACT_APP_WORMHOLE_BSC_BRIDGE_ADDRESS"),
  wormholeSOLBridgeAddress: getEnv("REACT_APP_WORMHOLE_SOL_BRIDGE_ADDRESS"),
  wormholeSOLMaxVAAUploadRetries:
    getEnv("REACT_APP_WORMHOLE_SOL_MAX_VAA_UPLOAD_RETRIES"),
  autoRouterContractAddress: getEnv("REACT_APP_AUTO_ROUTER_CONTRACT_ADDRESS"),
  evryLoansContractAddress: getEnv("REACT_APP_EVRYLOANS_CONTRACT_ADDRESS"),
  evryLensContractAddress: getEnv("REACT_APP_EVRY_LENS_CONTRACT_ADDRESS"),
  comptrollerContractAddress:
    getEnv("REACT_APP_COMPTROLLER_CONTRACT_ADDRESS"),
  treasuryEVHYAddress: getEnv("REACT_APP_TREASURY_EVHY_ADDRESS"),
  countdownGoal: getEnv("REACT_APP_COUNTDOWN_GOAL"),
  gas: {
    limitBufferPercentage: getEnv("REACT_APP_GAS_LIMIT_BUFFER_PERCENTAGE"),
    priceBufferPercentage: getEnv("REACT_APP_GAS_PRICE_BUFFER_PERCENTAGE"),
    pl: getEnv("REACT_APP_GAS_PL_ESTIMATED"),
  },
  feeTransfer: getEnv("REACT_APP_FEE_TRANSFER"),
  txDeadlineDefault: parseInt(getEnv("REACT_APP_TX_DEADLINE_DEFAULT") ?? "0"),
  blockPerDay: parseInt(getEnv("REACT_APP_BLOCK_PER_DAY_ESTIMATED") ?? "0"),
  token,
  farmToken,
  newFarmToken,
  earnOtherToken,
  lp,
  dmmLP,
  farm: [
    {
      contractAddress: getEnv("REACT_APP_FARM_CONTRACT_ADDRESS"),
      rewardToken: farmToken.EVRY_TOKEN,
      pairs: pairs.filter((pair) =>
        getEnv("REACT_APP_ENABLE_FEATURE_VELO") === "false"
          ? pair.id !== "VELO_TOKEN"
          : pair.id
      ),
      tokens: farmToken,
      ABIName: "Farms",
    },
    {
      contractAddress: getEnv("REACT_APP_COMMON_FARM_CONTRACT_ADDRESS"),
      rewardToken: newFarmToken.VELO_TOKEN,
      pairs: newPairs,
      tokens: newFarmToken,
    },
    {
      contractAddress: getEnv("REACT_APP_OMNI_FARM_CONTRACT_ADDRESS"),
      rewardToken: newFarmToken.OMNI_TOKEN,
      pairs: newPairOmniRewards,
      tokens: newFarmToken,
    },
  ],
  earnOtherNoFixedAPR: [
    // {
    //   contractAddress: getEnv("REACT_APP_EARN_OTHER_VELO_VELO"),
    //   rewardToken: earnOtherToken.VELO_TOKEN.code,
    //   id: earnOtherToken.VELO_TOKEN.code,
    //   staking: earnOtherToken.VELO_TOKEN,
    //   lpType: null,
    // },
    // {
    //   contractAddress: getEnv("REACT_APP_EARN_OTHER_GGC1_GGC1"),
    //   rewardToken: earnOtherToken.GGC1_TOKEN.code,
    //   id: earnOtherToken.GGC1_TOKEN.code,
    //   staking: earnOtherToken.GGC1_TOKEN,
    //   lpType: null,
    // },
  ],
  earnOtherFixedAPR: [
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_USDV_VELO"),
      rewardToken: fixAPRToken.VELO_TOKEN.code,
      id: fixAPRToken.USDV_TOKEN.code,
      staking: fixAPRToken.USDV_TOKEN,
      rewardPrice: fixAPRToken.VELO_TOKEN.fixedPrice,
      // rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardExternalPrice: true,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingPrice: fixAPRToken.USDV_TOKEN.fixedPrice,
      lpType: null,
    },
  ],
  earnOtherFixedAPRLock: [
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_30D_V4"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_30D_V5"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: false,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_30D_V3"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_30D_V2"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_90D_V1"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_90D_V2"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_90D_V3"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_90D_V4"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_90D_V5"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_90D_V6"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_90D_V7"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_90D_V8"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_90D_V9"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_90D_V10"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_90D_V11"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: false,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_90D_V11"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: false,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_180D_V1"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_180D_V2"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO_30D_V1"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: false,
      isExpired: true,
    },
    {
      contractAddress: getEnv("REACT_APP_FIX_APR_LOCK_VELO_VELO"),
      rewardToken: fixAPRLockToken.VELO_TOKEN.code,
      id: fixAPRLockToken.VELO_TOKEN.code,
      staking: fixAPRLockToken.VELO_TOKEN,
      rewardExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      stakingExternalPrice: fixAPRToken.VELO_TOKEN.externalPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      stakingSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      isDisabledDeposit: true,
      isExpired: true,
    },
  ],
  earnOtherFixedAPRLockChangeRatio: [
    {
      contractAddress:
        getEnv("REACT_APP_FIX_APR_LOCK_CHANGE_RATIO_USDV_VELO"),
      rewardToken: fixAPRLockTokenChangeRatio.VELO_TOKEN.code,
      id: fixAPRLockTokenChangeRatio.USDV_TOKEN.code,
      staking: fixAPRLockTokenChangeRatio.USDV_TOKEN,
      rewardExternalPrice: fixAPRLockTokenChangeRatio.VELO_TOKEN.externalPrice,
      stakingPrice: fixAPRLockTokenChangeRatio.USDV_TOKEN.fixedPrice,
      rewardSlug: fixAPRToken.VELO_TOKEN.slug,
      lpType: null,
      isHideTooltip: true,
      periodFix: "14",
      isExpired: true,
    },
  ],
  IDO: [
    // {
    //   contractAddress: getEnv("REACT_APP_IDO_GGC1"),
    //   spendingToken: IDOToken.USDT_TOKEN,
    //   id: IDOToken.GGC1_TOKEN.code,
    //   offeringToken: IDOToken.GGC1_TOKEN,
    //   lpType: null,
    // },
  ],
  bond: [
    {
      contractAddress: getEnv("REACT_APP_BOND_BUSD_CONTRACT_ADDRESS"),
      id: bondToken.BUSD_TOKEN.code,
      token: bondToken.BUSD_TOKEN,
      type: "stable",
    },
    {
      contractAddress: getEnv("REACT_APP_BOND_EVUSD_CONTRACT_ADDRESS"),
      id: bondToken.EVUSD_TOKEN.code,
      token: bondToken.EVUSD_TOKEN,
      type: "stable",
    },
  ],
  staking: {
    contractAddress: getEnv("REACT_APP_STAKING_CONTRACT_ADDRESS"),
    token: stakeToken.EVHY_TOKEN,
    rewardToken: stakeToken.SEVHY_TOKEN,
  },
  stakingHelper: {
    contractAddress: getEnv("REACT_APP_STAKING_HELPER_CONTRACT_ADDRESS"),
  },
  announcement: {
    twitter: getEnv("REACT_APP_ANNOUNCEMENT_TWITTER_URL"),
    medium: getEnv("REACT_APP_ANNOUNCEMENT_MEDIUM_URL"),
  },
  social: {
    telegram: getEnv("REACT_APP_SOCIAL_TELEGRAM_URL"),
    twitter: getEnv("REACT_APP_SOCIAL_TWITTER_URL"),
    medium: getEnv("REACT_APP_SOCIAL_MEDIUM_URL"),
  },
  velo: {
    homeUrl: getEnv("REACT_APP_VELO_HOME_URL"),
  },
  document: {
    home: getEnv("REACT_APP_DOCUMENT_HOME_URL"),
    learning: getEnv("REACT_APP_DOCUMENT_LEARNING_URL"),
    tokenomic: getEnv("REACT_APP_DOCUMENT_TOKENOMIC_URL"),
    roadmap: getEnv("REACT_APP_DOCUMENT_ROADMAP_URL"),
    liquidity: getEnv("REACT_APP_DOCUMENT_LIQUIDITY_POOL_URL"),
    amplifier: getEnv("REACT_APP_DOCUMENT_AMP_URL"),
    autoroute: getEnv("REACT_APP_DOCUMENT_AUTO_ROUTE_URL"),
    referral: getEnv("REACT_APP_DOCUMENT_REFERRAL_URL"),
  },
  externalPriceAPI: getEnv("REACT_APP_EXTERNAL_PRICE_API"),
  enableFeatureVelo: getEnv("REACT_APP_ENABLE_FEATURE_VELO"),
  solana: {
    goldrush: getEnv("REACT_APP_GOLDRUSH_URL"),
  },
  perpetual: {
    url: getEnv("REACT_APP_PERPETUAL_URL"),
  },
  binaryOption: [
    {
      contractAddress:
        getEnv("REACT_APP_BINARY_OPTION_BTC_USD_CONTRACT_ADDRESS"),
      oracleAddress: getEnv("REACT_APP_PRICE_FEED_BTC_USD_CONTRACT_ADDRESS"),
      betToken: token.VELO_TOKEN,
      oracleToken: oracleTokens.BTC_TOKEN,
      limit: 50,
      notiLimit: 32,
    },
  ],
  directExchange: [
    {
      contractAddress: getEnv("REACT_APP_DIRECT_EXCHANGE_EVRY_VELO"),
      originToken: token.EVRY_TOKEN,
      destinationToken: token.VELO_TOKEN,
      pairTokenImage: require("/src/assets/icons/token/velo-evry.svg").default,
      url: "https://www.velo.org/",
    },
    {
      contractAddress: getEnv("REACT_APP_DIRECT_EXCHANGE_USDV_OMNI"),
      originToken: token.MAIN_USDV_TOKEN,
      destinationToken: token.OMNI_TOKEN,
      pairTokenImage: require("/src/assets/icons/token/omni.svg").default,
      url: "https://www.velo.org/",
    },
    {
      contractAddress: getEnv("REACT_APP_DIRECT_EXCHANGE_USDT_USDV"),
      originToken: token.MAIN_USDV_TOKEN,
      destinationToken: token.USDT_TOKEN,
      pairTokenImage: require("/src/assets/icons/token/usdv-to-usdt-logo.svg").default,
      url: "https://www.velo.org/",
    },
  ],
  mlm: {
    backendEndpoint: getEnv("REACT_APP_MLM_BACKEND_ENDPOINT"),
  },
  networks,
  networkSol,
};

// Filter out configurations with undefined contract addresses
const filteredConfig = {
  ...config,
  earnOtherNoFixedAPR: config.earnOtherNoFixedAPR.filter(
    (item) => item.contractAddress && item.contractAddress.trim() !== ""
  ),
  earnOtherFixedAPR: config.earnOtherFixedAPR.filter(
    (item) => item.contractAddress && item.contractAddress.trim() !== ""
  ),
  earnOtherFixedAPRLock: config.earnOtherFixedAPRLock.filter(
    (item) => item.contractAddress && item.contractAddress.trim() !== ""
  ),
  earnOtherFixedAPRLockChangeRatio: config.earnOtherFixedAPRLockChangeRatio.filter(
    (item) => item.contractAddress && item.contractAddress.trim() !== ""
  ),
};

export default filteredConfig;
